import sectionCompareTwoImgCss from '../css-snippets/section-compare-two-img';

const html = `
<style>${sectionCompareTwoImgCss}</style>
<div data-attribute="card-container-unique-id" data-id="unique-id">
    <div class="container-page" data-attribute="container-page" data-show-style="false">
       <div class="wrap-card container">
          <div data-attribute="card-left" data-order="1" class="card-left" style="order: 1;">
             <div data-attribute="card-title" class="wrap-text">
                <h2 style="text-align:center;">Turn Screen Time into Creative Time🎨</h2>
             </div>
          </div>
          <div data-attribute="card-right" data-order="2" class="card-right" data-style-center-y="false" style="order: 2;">
             <div data-attribute="card-content" class="card-content">
                <div class="img-comp-container">
                    <div class="img-comp-img" style="width: 100%;">
                        <img loading="lazy" data-attribute="image-after" src="https://cdn.skyfastimg.com/images/2025/08/20/image-68a53cffadd39471e889fdf0.webp?w=500&h=50&q=80">
                    </div>
                    <div class="img-comp-slider"></div>
                    <div class="img-comp-img img-comp-overlay" style="width: 100%;">
                        <img loading="lazy" data-attribute="image-before" src="https://cdn.skyfastimg.com/images/2025/08/20/image-68a53cfaff4a88b29fc3617a.webp?w=500&h=50&q=80">
                    </div>
                    <div class="before-and-after">
                        <div data-attribute="before" data-background="#17d4f4" data-color="#ffffff" class="before" style="background-color: #17d4f4; color: #ffffff;">
                            Before
                        </div>
                        <div data-attribute="after" data-background="#17d4f4" data-color="#ffffff" class="after" style="background-color: #17d4f4; color: #ffffff;">
                            After
                        </div>
                    </div>
                </div>
             </div>
          </div>
       </div>
    </div>
</div>
`;
export default html;
